module.exports = __webpack_public_path__ + "img/table.777ec84b.jpg";